import { env } from 'common/config';

// TODO: there is a lot more going on here than authx config. Rename and move out from src/router?

// For anyone else that may come across this wondering - do not rely on env object to have values inside.
// Instead, rely directly on env[key] as those are going to be replaced directly in the code:
//
// env[key];    // val
// env;         // {}

/* DEV-START */
// override reportsApiBaseUrl in local dev env
// see also __mocks__/api/__reportsAPI__/GET.js

/* DEV-END */
export const authXRedirectUri = `${window.location.origin}/authorization/callback`;

export const authXConfig = {
    IAM: {
        clientId: env.CLIENT_ID,
        authority: env.KEYCLOAK_URL,
        baseURL: env.IAM_URL,
    },
    DAS: {
        sourceIds: env.DATA_ACCESS_SOURCE_IDS,
        organizationId: env.DATA_ACCESS_ORGANIZATION_ID,
    },
    API: {
        ReportsAPI: {
            baseURL: `https://api.${env.SUBDOMAIN}`,
            consoleLog: true,
        },
        DatasetsAPI: {
            baseURL: `https://api.${env.SUBDOMAIN}`,
            consoleLog: true,
        },
        WebSocketAPI: {
            baseURL: env.WS_URL,
            consoleLog: true,
        },
        ConfigAPI: {
            parkURL: `https://api.${env.SUBDOMAIN}/conf/parks`,
            regionURL: `https://api.${env.SUBDOMAIN}/conf/regions`,
            baseURL: env.CONFIG_API_URL,
            consoleLog: true,
        },
        CognitoAPI: {
            authURL: `https://cognito-auth.${env.SUBDOMAIN}/authenticate?redirectUri=${authXRedirectUri}`,
            loginURL: `https://cognito-auth.${env.SUBDOMAIN}/login`,
            logoutURL: `https://cognito-auth.${env.SUBDOMAIN}/logout`,
            userURL: `https://cognito-auth.${env.SUBDOMAIN}/api/v1/user`,
            consoleLog: true,
        },
        DataAccessAPI: {
            baseURL: env.DATA_ACCESS_API_URL,
            consoleLog: true,
            trailSize: 50,
        },
    },
};

if (authXConfig.IAM.clientId === undefined) {
    console.error('authXConfig.IAM.clientId is undefined');
}
